import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-po-amendment-form-list',
  templateUrl: './po-amendment-form-list.component.html',
  styleUrl: './po-amendment-form-list.component.css'
})
export class PoAmendmentFormListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'srNo',
    'poRef',
    'projectName',
    'amendmentType',
    'reason',
    'revisedTotal',
    'status',
    'createdAt',
    'action',
  ];

  dataSource = new MatTableDataSource<Record<string, unknown>>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  fetchData(): void {
    this.apiService.listPurchaseOrderAmendments().subscribe({
      next: (res: { data?: Record<string, unknown>[] }) => {
        this.dataSource.data = res.data || [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.message || 'Failed to load amendments');
      },
    });
  }

  viewPo(row: { po_id?: number }): void {
    if (row.po_id) {
      void this.router.navigate(['/home/purchase-order', row.po_id]);
    }
  }
}
